export default class SoundGroup {
    constructor(name) {
        this._name = name;
        this._muted = false;
        this._volume = 1;
        this._sounds = new Map();
    }

    addSound(sound, alias) {
        sound.muted = this.muted;
        sound.volume *= this.volume;
        sound.instances[0].on('end', (event) => {
            this._onSoundEnd(sound);
        }, this);
        this._sounds.set(alias, sound);
    }

    getSound(alias) {
        return this._sounds.get(alias);
    }

    _onSoundEnd(sound) {

    }

    switchMuted() {
        this.muted = !this.muted;
    }

    destroy() {

    }

    get muted() {
        return this._muted;
    }

    set muted(value) {
        this._muted = value;
        this._sounds.forEach((sound, key) =>  {
            sound.muted = this.muted;
        });
    }

    get volume() {
        return this._volume;
    }

    set volume(value) {
        this._volume = value;
        this._sounds.forEach((sound, key) =>  {
            sound.volume = this.volume;
        });
    }

    get sounds() {
        return this._sounds;
    }

    get name() {
        return this._name;
    }
}